import React, { useState, useEffect } from "react";

const HeaderMail = () => {
  return (
    <div className="p-2">
      <div
        className="flex flex-column md:flex-row justify-content-between md:align-items-end mb-4"
        style={{ paddingBottom: "10px" }}
      >
        <div className="mb-3 md:mb-0">
          <h2
            className="m-0"
            style={{
              fontSize: "1.6rem",
              fontWeight: "700",
              letterSpacing: "-0.5px",
            }}
          >
            Modifications des Mails
          </h2>
        </div>
      </div>
    </div>
  );
};

export default HeaderMail;
